import React, { Component } from 'react';
import Logo from "./Logo";
import Menu from "../content/menu/Menu";

class Header extends Component{

    render(){
        return (
            <header role="banner" id="header">
                <div className="header-inner">
                    <div className="header-content">
                        <div className="c-container">
                            <div className="header-content-inner">
                                <Logo src="./logo.gif" alt="Logo TSM" width="200" height="200"/>
                                <nav className="header-menu">
                                    <Menu pages={this.props.pages}/>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default Header


// WEBPACK FOOTER //
// ./src/components/header/Header.js